import { Amount } from "../amount"
import { AirClass } from "../air-fare"
import { AType, summon, tagged } from "@silversea-ssc/functional-support"

export const Promo = summon((F) =>
    F.keysOf({
        VS: null,
        VSMembership: null,
        KidsSaving: null,
        Generic: null,
        D2D: null,
        PriceDowngrade: null,
        ShipboardCredit: null,
        Discount: null,
    }),
)
export type Promo = AType<typeof Promo>

export const PriceDetailCruise = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("Cruise"),
            price: Amount(F),
        },
        "PriceDetailCruise",
    ),
)
export type PriceDetailCruise = AType<typeof PriceDetailCruise>

export const PriceDetailPromo = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("Promo"),
            promo: Promo(F),
            percentage: F.nullable(F.number()),
            credit: F.nullable(Amount(F)),
            discount: Amount(F),
            configurationCode: F.nullable(F.string()),
        },
        "PriceDetailPromo",
    ),
)
export type PriceDetailPromo = AType<typeof PriceDetailPromo>

export const PriceDetailAir = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("Air"),
            price: Amount(F),
            from: F.string(),
            to: F.string(),
            airClass: AirClass(F),
            isPromotional: F.boolean(),
        },
        "PriceDetailAir",
    ),
)
export type PriceDetailAir = AType<typeof PriceDetailAir>

export const PriceDetailGeneric = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("Generic"),
            category: F.keysOf({ unknown: null, hotel: null }),
            amount: Amount(F),
        },
        "PriceDetailGeneric",
    ),
)
export type PriceDetailGeneric = AType<typeof PriceDetailGeneric>

const _PriceDetail = tagged("type")({
    Cruise: PriceDetailCruise,
    Promo: PriceDetailPromo,
    Air: PriceDetailAir,
    Generic: PriceDetailGeneric,
})
export type PriceDetail = AType<typeof _PriceDetail>

export const PriceDetail = /* @__PURE__ */ Object.assign(_PriceDetail, {
    amount: _PriceDetail.match({
        Promo: (v) => v.discount,
        Air: (v) => v.price,
        Cruise: (v) => v.price,
        Generic: (v) => v.amount,
    }),
})
